import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { SystemEventListPanel } from "@/features/admin/components/system-event-list-panel";

/**
 * Resources & IAN links (`/admin/resources`) — two independently ordered lists:
 * general Resources (optionally password-gated) and IRS Advance Notice links.
 */
export default function ResourcesPage() {
  return (
    <Tabs defaultValue="RESOURCE">
      <TabsList>
        <TabsTrigger value="RESOURCE">Resources</TabsTrigger>
        <TabsTrigger value="IAN">IAN links</TabsTrigger>
      </TabsList>
      <TabsContent value="RESOURCE" className="mt-4">
        <SystemEventListPanel
          title="Resources"
          description="Reference links shown to every firm; may be password-gated."
          addLabel="Add Resource"
          resource="resources"
          selector={{ param: "kind", value: "RESOURCE" }}
          fields={["title", "href", "newTab", "detail", "password"]}
          columns={[
            { header: "Title", cell: (e) => <span className="font-medium">{e.title}</span> },
            { header: "URL", cell: (e) => e.href || "—" },
            { header: "Gated", cell: (e) => (e.passwordProtected ? "Yes" : "No") },
          ]}
        />
      </TabsContent>
      <TabsContent value="IAN" className="mt-4">
        <SystemEventListPanel
          title="IAN links"
          description="IRS Advance Notice links."
          addLabel="Add IAN"
          resource="resources"
          selector={{ param: "kind", value: "IAN" }}
          fields={["title", "href", "newTab"]}
          columns={[
            { header: "Title", cell: (e) => <span className="font-medium">{e.title}</span> },
            { header: "URL", cell: (e) => e.href || "—" },
          ]}
        />
      </TabsContent>
    </Tabs>
  );
}
